import { useHistory } from "react-router";
import styled from "styled-components";
import FavLogo from "../../assets/logo.png";
import { ThisPaths } from "../../shared/Constants";
import { useWindowDimension } from "../../shared/utils/CustomHooks";

export const UserSessionSpan = styled.span`
    display: "inline-block";
    width: 18vw;
    text-align: center;
    margin: 4%;

    @media (max-width: 1250px) {
        width: 28vw;
    }

    @media (max-width: 900px) {
        width: 38vw;
    }

    @media (max-width: 500px) {
        width: 75vw;
    }
`;

interface Props {
    baseHeight?: number;
    isHeaderIcon?: boolean;
}

export const MainLogo: React.FC<Props> = ({
    baseHeight = 13,
    isHeaderIcon = false,
}) => {
    const history = useHistory();
    const dimensions = useWindowDimension();

    const getHeight = () => {
        if (isHeaderIcon) return (dimensions.height * baseHeight) / 100;
        if (dimensions.height <= 1080)
            return (dimensions.height * baseHeight) / 100;

        return "20%";
    };

    return (
        <img
            src={FavLogo}
            alt="logo"
            style={{
                width: "auto",
                cursor: "pointer",
                margin: "1%",
                height: getHeight(),
            }}
            onClick={() => history.replace(ThisPaths.LOGIN)}
        />
    );
};
